import AsyncButton from '@wojtekmaj/react-async-button';
import T, { useTranslation } from '@wojtekmaj/react-t';

import { toast } from '@rewardopl/react-toast';

import Button from '@rewardopl/react-ui/button';

import { post } from '@rewardopl/utils/network';

import type { Reward, Transaction } from '@rewardopl/types';
import type { SetStateAction } from 'jotai';

const pendingConfig = {
  disabled: true,
};

type ActivateButtonProps = {
  disabled?: boolean;
  onSuccess: (nextTransaction: Transaction) => void;
  reward: Reward;
  setTransactions: (nextValueOrSetter: SetStateAction<Transaction[]>) => void;
};

export default function ActivateButton({
  disabled,
  onSuccess,
  reward,
  setTransactions,
}: ActivateButtonProps) {
  const rewardErrorString = useTranslation('Failed to buy the reward');

  const { _id: rewardId, card_id: cardId } = reward;

  async function onClick() {
    try {
      const nextTransaction = (await post(
        `/api/cards/${cardId}/rewards/${rewardId}/buy`,
      )) as Transaction;

      setTransactions((prevTransactions) => [nextTransaction, ...prevTransactions]);

      onSuccess(nextTransaction);
    } catch {
      toast.error(rewardErrorString);
    }
  }

  return (
    <AsyncButton
      as={Button}
      className="primary"
      disabled={disabled}
      onClick={onClick}
      pendingConfig={pendingConfig}
      type="button"
    >
      <T>Activate</T>
    </AsyncButton>
  );
}
